// extracted by mini-css-extract-plugin
export var quantityInput = "_ho-0";